<template>
  <v-navigation-drawer v-model="drawer" color="grey-lighten-5" class="text-button">
    <v-list-subheader class="text-grey-darken-2 text-button pt-2">
      {{ heading }}
    </v-list-subheader>
    <v-divider class="border-opacity-25" />
    <v-list nav density="compact">
      <v-list-item
        v-for="section in visibleSections"
        :key="section.path"
        :to="section.path"
        active-class="text-indigo"
      >
        <template #prepend>
          <v-icon color="grey-darken-2">{{ section.icon }}</v-icon>
        </template>
        <v-list-item-title class="text-grey-darken-2">
          {{ section.label }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <v-divider class="border-opacity-25" />
  </v-navigation-drawer>
</template>

<script setup lang="ts">
/**
 * El drawer de navegación, uno para los tres portales.
 *
 * Antes eran tres componentes casi idénticos (AgAdminDrawer, AgMyDrawer,
 * AgSystemDrawer) con los ítems escritos a mano y SIN chequear roles: un usuario
 * con sólo ADMIN_KEYS veía las cuatro entradas de administración y chocaba con
 * 403 silenciosos al hacer clic.
 *
 * Ahora los ítems salen de sections.ts —la misma tabla que usan los guards del
 * router— y se filtran con auth.canAccess, así que el menú y los permisos no
 * pueden discrepar.
 */
import { computed } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useLayoutStore } from "@/stores/layout";
import { useAuthStore } from "@/stores/auth";
import { ADMIN_SECTIONS, MY_SECTIONS, SYSTEM_SECTIONS } from "@/router/sections";

const route = useRoute();
const auth = useAuthStore();
const { drawer } = storeToRefs(useLayoutStore());

const group = computed(() => {
  switch (route.meta.prefix) {
    case "/admin":
      return { heading: "Administrar", sections: ADMIN_SECTIONS };
    case "/system":
      return { heading: "Sistema", sections: SYSTEM_SECTIONS };
    default:
      return { heading: "Mi cuenta", sections: MY_SECTIONS };
  }
});

const heading = computed(() => group.value.heading);
const visibleSections = computed(() =>
  group.value.sections.filter((s) => auth.canAccess(s.roles))
);
</script>
